<template>
  <div class="relative h-[585px] md:h-[450px]">
    <div class="container relative z-10">
      <div
        class="bg-white py-[30px] px-[20px] rounded-[12px] support-card"
        :class="{
          '!bg-gray-4 !border-gray-4': type == 6,
        }"
      >
        <h2
          class="text-mobile-heading-2 md:text-heading-2 title-font text-primary-1 mb-5"
        >
          {{ t("index.supportTitle") }}
        </h2>
        <div class="text-mobile-paragraph-1 md:text-paragraph-1 text-gray-1">
          {{ t("index.supportDescription") }}
        </div>
        <div
          class="flex max-md:flex-col justify-between gap-[30px] md:gap-[100px] mt-[30px]"
        >
          <div class="md:w-[48%]" :class="{ 'max-w-64': type == 6 }">
            <div
              class="support-icon"
              :class="{ '!bg-transparent relative': type == 6 }"
            >
              <NuxtImg
                loading="lazy"
                src="paint-splash-6.svg"
                class="left-1/2 -translate-x-[48%] min-w-[104px] min-h-[100px] absolute z-10"
                v-if="type == 6"
              />
              <icon-location class="z-20" />
            </div>
            <div class="info">
              {{ info?.address.address_description }}
            </div>
          </div>
          <div class="md:w-[30%]">
            <div
              class="support-icon"
              :class="{ '!bg-transparent relative': type == 6 }"
            >
              <NuxtImg
                loading="lazy"
                src="paint-splash-7.svg"
                class="left-1/2 -translate-x-[48%] min-w-[104px] min-h-[100px] absolute z-10"
                v-if="type == 6"
              />
              <icon-email class="z-20" />
            </div>
            <a v-if="info?.email" class="info" :href="`mailto:${info?.email}`">
              {{ info?.email }}
            </a>
          </div>
          <div class="md:w-[22%]">
            <div
              class="support-icon"
              :class="{ '!bg-transparent relative': type == 6 }"
            >
              <NuxtImg
                loading="lazy"
                src="paint-splash-8.svg"
                class="left-1/2 -translate-x-[48%] min-w-[104px] min-h-[100px] absolute z-10"
                v-if="type == 6"
              />
              <icon-call class="z-20" />
            </div>

            <a
              v-for="(item, index) in info?.telephones"
              :tel="item"
              :href="`tel:${item}`"
              class="info"
            >
              <span dir="ltr">{{ item }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <NuxtImg
      loading="lazy"
      :src="supportImage"
      class="w-full h-[360px] md:h-[340px] object-cover absolute bottom-0 z-0"
    />
    <div class="support-cover"></div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import type { ICompanyInfo } from "../../../types/general";
import { ref } from "vue";
import { useAsyncData } from "nuxt/app";

const props = defineProps({
  type: {
    type: Number,
    default: 1,
  },
});
const locale = useCookie("locale").value;
const { data: info } = await useAsyncData<ICompanyInfo | null>(
  `about-${locale}`,
  () => customFetch(`api/company-info?lang=${locale}`)
);
const { t } = useI18n();

function openLink(url: string) {
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  window.open(url, "_blank");
  // window.location.replace(url);
}
// function dynamicIcon(item: string) {
//   return `icon-${item?.replace(/[\W_]+/g, "")}`;
// }

const config = useRuntimeConfig();
const supportImageSrc =
  (config.public.supplierStatic as any)?.supportImageSrc || null;

const supportImage = computed(() => {
  return supportImageSrc ? supportImageSrc : "/support.png";
});
</script>

<style scoped lang="scss">
.support-card {
  @apply p-[40px] rounded-[20px] border border-gray-3 relative;
  .support-icon {
    @apply bg-primary-2 text-white p-2 mb-[10px] md:mb-[20px] rounded-[10px] w-[44px] h-[44px] flex items-center justify-center;
    svg {
      @apply text-[19px];
    }
  }
  .info {
    @apply text-mobile-heading-6 md:text-heading-6 text-gray-1;
  }
}
.support-cover {
  @apply w-full h-[360px] md:h-[340px] object-cover absolute bottom-0 z-0;
  background-image: linear-gradient(
    rgba(242, 240, 237, 1),
    rgba(245, 245, 250, 0.7),
    rgba(245, 245, 250, 0)
  );
}
</style>
